import { useNavigate, useParams } from 'react-router-dom';

import { PageHeader } from '@backrs_ui/common-ui';

import { APP_ROUTE } from '@backrs_ui/grow-ui/src/appRoutes.constants';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';
import { selectSharedSessionOwnerFirstName } from '@backrs_ui/grow-ui/src/redux/sharedSession/sharedSession';

import { Button } from '@mui/material';

const HEADER_STRINGS = appStrings.modules.educationalInvestment.header;

type EducationalInvestmentHeaderProps = Readonly<{
  isShared: boolean;
}>;

export const EducationalInvestmentHeader = ({
  isShared = false,
}: EducationalInvestmentHeaderProps) => {
  const navigate = useNavigate();
  const params = useParams();
  const sharedSessionUUID = params.uuid;

  const doesUserHaveBlueprint = useAppSelector(
    (state) => state.userResponseSet.mostRecentUserResponseSet?.user_responses,
  );
  const sharedOwnerFirstName = useAppSelector(selectSharedSessionOwnerFirstName);

  const handleBlueprintClick = () => {
    if (isShared) {
      navigate(APP_ROUTE.SHARED_MY_BLUEPRINT.replace(':uuid', sharedSessionUUID || ''));

      return;
    }

    navigate(doesUserHaveBlueprint ? APP_ROUTE.MY_BLUEPRINT : APP_ROUTE.SURVEY);
  };

  const blueprintButton = (
    <Button
      id="educational-investment-my-blueprint-button"
      variant="contained"
      hierarchy="Primary"
      size="md"
      onClick={handleBlueprintClick}
    >
      {HEADER_STRINGS.myBlueprint(isShared ? sharedOwnerFirstName : undefined)}
    </Button>
  );

  return (
    <PageHeader
      title={HEADER_STRINGS.title}
      subtitle={HEADER_STRINGS.subtitle}
      rightComponents={[blueprintButton]}
      maxWidth={null}
    />
  );
};
